/**
 * Service layer — deleting a milestone so the schedule heals (docs/OPERATING_MODEL.md, 2026-09-24).
 * Talks to /api/milestone-delete only.
 */
async function authToken() {
  if (typeof window === 'undefined') return null
  for (let i = 0; i < 20; i++) {
    if (typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* not ready */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}
async function post(body) {
  const token = await authToken()
  const res = await fetch('/api/milestone-delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || ('Request failed: ' + res.status))
  return json
}

/** What deleting would do: { deleting, group, waitedOn, loose, choices }. */
export function planMilestoneDelete(milestoneId, alsoDelete = []) { return post({ action: 'plan', milestoneId, alsoDelete }) }
/** relinks: [{ id, predecessorIds: [...] } | { id, fixedStart: 'YYYY-MM-DD' }] */
export function applyMilestoneDelete(milestoneId, alsoDelete, relinks) { return post({ action: 'apply', milestoneId, alsoDelete, relinks }) }
